import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useUser } from '../../context/UserContext';
import YEAR_ADDYEARFORM from '../../partials/years/year-add-year-form';
import YEAR_CURRENTYEAR from '../../partials/years/year-current-year';

const Year = () => {
	//***********//
	const navigate = useNavigate()
	const { user } = useUser()
	const [inputValue, setInputValue] = useState({
		endDate:""
	})
	const {endDate} = inputValue;
	const handleOnChange = (e) => {
		const {name,value} = e.target
		setInputValue({
			...inputValue,
			[name]:value
		})
	}
	
	const handleError = (error) =>
		toast.error(error, {
			position:"top-right"
		})
	const handleSuccess = (message) =>
		toast.success(message, {
			position:"top-right"
		})
	
	const [activeYear, setActiveYear] = useState(null)
	const [yearsData, setYearsData] = useState(null)
	const [isLoading, setIsLoading] = useState(true)
	//***********//

	// Sort years
	function sortYearsByDateEndingSoonest(data) {
		data = data.sort((a,b) => {
			if(a.endDate < b.endDate) {
				return -1;
			} if(a.endDate > b.endDate) {
				return 1;
			}
			return 0;
		})
		return data
	}

	//Is there a Current Year active?
	async function currentYearActive() {
		try {
			const {data} = await axios.post(
				`${process.env.REACT_APP_WEB_URL}api/year/get-current-active-year`,
				{...inputValue},
				{withCredentials:true}
			)

			// sort by endDate ending soonest
			if(data) {
				let yearsSorted = sortYearsByDateEndingSoonest(data)
				if(yearsSorted[0]){
					setActiveYear(true)
					setYearsData(yearsSorted) // Store the years data in state
					return yearsSorted
				}
				setActiveYear(false)
				setYearsData(null)
				return false
			}
			setActiveYear(false)
			setYearsData(null)
			return false
		}catch(error){
			setActiveYear(false)
			setYearsData(null)
			return error
		} finally {
			setIsLoading(false)
		}
	}

	// Effect to check for active year when user_id is available
	useEffect(() => {
		if (user?.user_id) {
			currentYearActive()
		}
	}, [user?.user_id]) // Only run when user_id changes

	// Create Year
	const createYear = async(e) => {
		e.preventDefault()
		try {
			const {data} = await axios.post(
				`${process.env.REACT_APP_WEB_URL}api/year/start-year`,
				{...inputValue},
				{withCredentials:true}
			)
			const {success,message} = data
			if(success) {
				handleSuccess(message)
				// Re-check for active year after creating one
				await currentYearActive()
			}else{
				handleError(data)
			}
		}catch(error){
			console.log(error)
		}
	}

	// Show loading state while checking for active year
	if (isLoading) {
		return (
			<>
				<div className="year">
					<div>Loading...</div>
				</div>
				<ToastContainer />
			</>
		)
	}

	return (
		<>
			<div className="manage-your-year">
				<h1 className="text-align--center">Manage your year</h1>
				<div className="year">
					{ activeYear ? <YEAR_CURRENTYEAR activeYear={yearsData} refreshYear={currentYearActive} /> : <YEAR_ADDYEARFORM endDate={endDate} handleOnChange={handleOnChange} createYear={createYear} /> }
				</div>
				<ToastContainer />
			</div>
			</>
	);
};

export default Year
